import { fromJS } from 'immutable';
import { createReducer } from '../../utils/helpers';
import { casesSummary } from './types';

const initialState = fromJS({
  data: null,
  loading: true,
  error: false,
});

export default createReducer(initialState, {
  [casesSummary.request]: (state) => state.set('loading', true),
  [casesSummary.success]: (state, action) =>
    state.set('loading', false).set('error', false).set('data', action.response),
  [casesSummary.failure]: (state, action) => state.set('loading', false).set('error', action.error),
});
